import { Icon24AspectRatioOn } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import { LinkIcon } from './LinkIcon';

export const AspectRatioOnIcon = fplIcon(LinkIcon, Icon24AspectRatioOn);
